import { createReducer, on, StoreModule } from '@ngrx/store';
import { RideGroupAlert } from 'src/app/models/ride-group-alert';
import { RideGroupMessage } from 'src/app/models/ride-group-message';
import {
    SetGroupRideAlerts,
    SetGroupRideMessages,
    SetGroupRideMessageTime,
    SetHasNewAlerts,
    SetHasNewMessages,
} from './group-ride-message.actions';

export const groupRideMessageFeatureKey = 'groupRideMessageState';

export interface GroupRideMessageState {
    messages: RideGroupMessage[];
    alerts: RideGroupAlert[];
    time: string;
    hasNewMessages: boolean;
    hasNewAlerts: boolean;
}

const initialState: GroupRideMessageState = {
    alerts: [],
    hasNewAlerts: false,
    hasNewMessages: false,
    messages: [],
    time: '',
};

export const groupRideMessageReducer = createReducer(
    initialState,
    on(SetGroupRideMessages, (state, { messages }) => {
        return { ...state, messages };
    }),
    on(SetGroupRideAlerts, (state, { alerts }) => {
        return { ...state, alerts };
    }),
    on(SetGroupRideMessageTime, (state, { time }) => {
        return { ...state, time };
    }),
    on(SetHasNewMessages, (state, { hasNewMessages }) => {
        return { ...state, hasNewMessages };
    }),
    on(SetHasNewAlerts, (state, { hasNewAlerts }) => {
        return { ...state, hasNewAlerts };
    })
);

export const groupRideMessageStoreModule = StoreModule.forFeature(
    groupRideMessageFeatureKey,
    groupRideMessageReducer
);
